<span class="navigation-button-label"><%= text %></span>
